module.exports = __webpack_public_path__ + "static/img/nl.b35389a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/nl.png
// module id = rN2T
// module chunks = 18